﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
import { AppLog } from "../AppLog";
export class GuiListDokument extends GuiListGeneric {

    constructor() {
        super("Dokument");
    }

    // attachListEvents statt attachEvents: GuiFilterSort ersetzt bei Filter/Sortierung/Blaettern
    // den kompletten div.erz-list-body und ruft danach nur diesen Hook erneut auf. In
    // attachEvents (GuiBase, einmalig im Konstruktor) gebundene Handler waeren danach weg.
    protected attachListEvents() {
        super.attachListEvents();

        $("div.erz-list-element button.trash").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickDeleteDokument(e));
        $("div.erz-list-element input.dok-toggle").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickToggleAnzeige(e));
        $("div.erz-list-element input.bestell-toggle").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickBestellAnzeige(e));
    } 
     
    clickDeleteDokument(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        AppLog.logInfo("clickDeleteDokument");
        e.preventDefault(); 

        const id = $(e.currentTarget).closest("div.erz-list-element").data("id");
        const baseUrl = $("div.erz-list").data("delete-url");
        const url = `${baseUrl}?dokumentId=${id}`;
        this.gotoUrl(url);
    }

    clickToggleAnzeige(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        AppLog.logInfo("clickToggleAnzeige");
        e.preventDefault();

        const dokumentId = $(e.currentTarget).closest("div.erz-list-element").data("id");
        const baseUrl = $("div.erz-list").data("toggle-url");
        const url = `${baseUrl}?dokumentId=${dokumentId}`;
        this.gotoUrl(url);
    }

    clickBestellAnzeige(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        AppLog.logInfo("clickBestellAnzeige");
        e.preventDefault();

        const dokumentId = $(e.currentTarget).closest("div.erz-list-element").data("id");
        const baseUrl = $("div.erz-list").data("toggle-bestell-url");
        const url = `${baseUrl}?dokumentId=${dokumentId}`;
        this.gotoUrl(url);
    }

    protected clickRow() {
        this.log("clickRow");
    }

    upload() {
        AppLog.logInfo("upload");

        $("#frmUpload").submit();
    }
}

